// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1498":"css/admin-app.6966","7000":"css/app.6966"}[chunkId] + ".css";
};